import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { authTypeOptionsConstant } from 'src/app/constants/service.constants';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteOperationsRenderer } from 'src/app/common/client-grid/delete-operations.component';
import { GridApi } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from '../../../common/message-box/message-box.component';
import * as $ from 'jquery';
import { CommonService } from '../../../services/common.service';
import { DeleteBoxComponent } from '../../../common/delete-box/delete-box.component';
import { eapTypeRequest } from 'src/app/models/EAP_Type/EAP_Type_Doc_type';
import { EapTypeReorderComponent } from '../eap-type-reorder/eap-type-reorder.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentTypeAddComponent } from 'src/app/common/document-type-add/document-type-add.component';

@Component({
  selector: 'app-eap-type-view',
  templateUrl: './eap-type-view.component.html',
  styleUrls: ['./eap-type-view.component.scss']
})
export class EapTypeViewComponent implements OnInit {

  @Input() public Content: any;
  content: any;
  heading: string;
  formFields;
  chooseoptions = authTypeOptionsConstant;
  ETypeForm: UntypedFormGroup;
  operations = [];
  tempoperations: any[];
  columnDefs;
  gridApi: GridApi;
  rowData;
  formDate: any[] = [];
  DocumentData: any[] = [];
  context;
  gridOptions;
  CancelButton: string = "Cancel";
  straction: string = "";
  strStatus: boolean = true;
  EAPName: string = null;
  frameworkComponents;
  action: Subject<any> = new Subject();
  loadGrid: boolean = true;
  Disable: boolean = false;
  selectedRow: any;
  RequiredSetting: boolean = true;

  constructor(
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private commonservice: CommonService,
    public commonService: CommonService
  ) {

  }
  ngOnInit() {
    this.ETypeForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      NAME: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
      RECORD_STATE: new UntypedFormControl(true),
    });

    this.columnDefs = [
      {
        "headerName": "Document Name",
        "field": "DocumentName"
      },
      {
        "headerName": "Status",
        "field": "IS_ACTIVE"
      },
      {
        "headerName": "Mandatory",
        "field": "ISMANDATORYStr"
      },
      {
        "headerName": "Allow Multiple Fields",
        "field": "ISSUPPORTMULTIPLEDOCUMENTSStr"
      }
    ];

    this.tempoperations = [];

    if (this.Content.heading == "Edit" || this.Content.heading == 'Add') {
      this.RequiredSetting = true;
      this.tempoperations = [
        {
          "name": "Edit",
          "id": "edit"
        },
        {
          "name": "Delete",
          "id": "DeleteDocument"
        }
      ];
    }

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    if (this.Content.heading == "View") {
      this.RequiredSetting = false;
      this.Disable = true;
      this.GetEditData();
      this.ETypeForm.disable();
      this.CancelButton = "Close";
      this.EAPName = null;
    }
    if (this.Content.heading == "Edit") {
      this.GetEditData();
    }
  }
  //to get main grid data
  setSummary() {
     ;
    this.summaryService.getSummaryData('api/EAPType/GetSummaryData').subscribe(summary => {
      this.rowData = summary
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  listSorted(event: any) {
    //console.log(event);
  }

  AddDocuments(event, straction) {
    if (event.IS_ACTIVE == "Inactive") {
      this.strStatus = false;
    }
    else {
      this.strStatus = true;
    }

    let modalRef = this.modalService.open(DocumentTypeAddComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: straction,
      content: { id: this.Content.content.id, TargetScreen: "EAPType", DocID: event.ID, DocName: event.DocumentName, Status: this.strStatus, ISMANDATORY: event.ISMANDATORY, ISMULTIDOC: event.ISSUPPORTMULTIPLEDOCUMENTS,DocList:this.DocumentData}
    }
    modalRef.result.then((result) => {
      result.ID = this.commonService.getUniqueId();
      result.DocumentName = result.DocumentName;
      result.IS_ACTIVE = result.IS_ACTIVE ? "Active" : "Inactive";
      result.ISMANDATORY = result.ISMANDATORY;
      result.ISSUPPORTMULTIPLEDOCUMENTS = result.ISSUPPORTMULTIPLEDOCUMENTS;
      result.ISMANDATORYStr = result.ISMANDATORY == true ? "Yes" : "No";
      result.ISSUPPORTMULTIPLEDOCUMENTSStr = result.ISSUPPORTMULTIPLEDOCUMENTS == true ? "Yes" : "No";
      let hasValue = this.DocumentData.filter(x => x.DocumentName.toLowerCase() == result.DocumentName.toLowerCase());
      if (hasValue.length > 0) {
        this.commonService.ValidationBanner( 'Document ' + result.DocumentName + ' already exists. Please provide new Document Name to save the details' );
      } else {
      // this.DocumentData.push(result);  
      this.DocumentData.splice(0, 0, result);     
       // this.commonService.SuccessBanner('Document ' + result.DocumentName + ' added successfully');
      }

      this.loadGrid = false;
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    });
   
  }

  edit() {
    if (this['self'].selectedRow.IS_ACTIVE == "Inactive") {
      this.strStatus = false;
    }
    else {
      this.strStatus = true;
    }

    let modalRef = this.modalService.open(DocumentTypeAddComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: {
        id: this['self'].Content.content.id, TargetScreen: "EAPType", DocID: this['self'].selectedRow.ID, DocName: this['self'].selectedRow.DocumentName, Status: this.strStatus, ISMANDATORY: this['self'].selectedRow.ISMANDATORY, ISMULTIDOC: this['self'].selectedRow.ISSUPPORTMULTIPLEDOCUMENTS,
        SequenceNum: this['self'].selectedRow.SequenceNum, DocList: this['self'].DocumentData
      }
    }
    modalRef.result.then(result => {
      result.ID = result.DocID;
      this["self"].loadGrid = false;
      this["self"].DocumentData.forEach((item) => {
        if (result.ID === item.ID) {
          let hasValue = this["self"].DocumentData.filter(x => x.DocumentName.toLowerCase() == result.DocumentName.toLowerCase() && x.ID != result.ID);
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner( 'Document ' + result.DocumentName + ' already exists. Please provide new Document Name to save the details');
            //this["self"].modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: 'Document ' + result.DocumentName + ' already exists. Please provide new Document Name to save the details' } } });
          }
          else {
            item.DocumentName = result.DocumentName;
            item.IS_ACTIVE = result.IS_ACTIVE ? "Active" : "Inactive";
            item.ISMANDATORY = result.ISMANDATORY;
            item.ISSUPPORTMULTIPLEDOCUMENTS = result.ISSUPPORTMULTIPLEDOCUMENTS;
            item.ISMANDATORYStr = result.ISMANDATORY == true ? "Yes" : "No";
            item.ISSUPPORTMULTIPLEDOCUMENTSStr = result.ISSUPPORTMULTIPLEDOCUMENTS == true ? "Yes" : "No";
           // this["self"].commonService.SuccessBanner('Document ' + result.DocumentName + ' updated successfully');
          }
        }
        setTimeout(() => {
          this["self"].loadGrid = true;
          document.body.click();
        }, 300);
      });

    });
  }


  ClosePopup() {
    this.modalRef.dismiss();
    // this.action.next();
  }

  SaveNewType() {
     ;
    if (this.validateControls()) {
      let requestData: eapTypeRequest = {
        docs: !this.DocumentData ? [] : this.DocumentData,
        ID: this.ETypeForm.controls["ID"].value,
        NAME: this.ETypeForm.controls["NAME"].value,
        RECORD_STATE: this.ETypeForm.controls["RECORD_STATE"].value,
      }
      if (this.Content.heading === "Add") {
        this.summaryService.Insert('api/EAPType/Insert', requestData).subscribe(summary => {
          if (summary.Status === 0) {
            this.commonservice.SuccessBanner(summary.Message);
           // this.action.next(requestData);
            this.modalRef.close();
          }
          else {
            this.commonService.ValidationBanner(summary.Message);
          }
        });
      }
      if (this.Content.heading === "Edit") {
        this.summaryService.Insert('api/EAPType/Update', requestData).subscribe(summary => {
          if (summary.Status == 0) {
            this.commonservice.SuccessBanner(summary.Message);
           // this.action.next(requestData);
            this.modalRef.close();
          }
          else {
            this.commonService.ValidationBanner(summary.Message);
            // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: summary.Message} } });
          }
        });
      }
    }
  }

  validateControls(): boolean {
     ;
    let isValid = true;
    let message = "";
    const formData = this.ETypeForm.getRawValue();

    if (formData.NAME === null || formData.NAME === "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter EAP Type<br/>";
      isValid = false;
    } else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }
    if (this.DocumentData != null && this.DocumentData.length == 0) {
      message += "Please add Documents<br/>";
      isValid = false;
    }
    if (!isValid)
      this.commonService.ValidationBanner(message);
    // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }
  GetEditData(): void {
     ;
    this.summaryService.getRecord('api/EAPType/Edit?RecordID=' + this.Content.content.id).subscribe(summary => {
      if (summary != null && summary != undefined) {
        this.ETypeForm.patchValue({
          ID: summary["ID"],
          NAME: summary["NAME"],
          RECORD_STATE: summary["RECORD_STATE"],
        });
        this.DocumentData = summary["docs"];
        if (this.Content.heading == "View") {
          this.ETypeForm.disable();
        }
        if (this.Content.heading == "Edit") {
          this.EAPName = summary["NAME"];
        }
      }
    });
  }

  DeleteDocument() {
    let RecordID = this['self'].selectedRow.ID;
    let NAME = this['self'].selectedRow.DocumentName;
    //this.modalRef = this.modalService.show(DeleteBoxComponent);
    let modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false
    });
    modalRef.componentInstance.Content = { heading: 'Delete Document', custommessage: 'Are you sure you want to delete the document ' + NAME + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" } 
    modalRef.result.then(result => {
      if (result == "okclick") {
        this["self"].loadGrid = false;
        let val = this['self'].DocumentData.findIndex(x => x.ID == RecordID);
        this['self'].DocumentData.splice(val, 1);
      }

      setTimeout(() => {
        this["self"].loadGrid = true;
        //document.body.click();
      }, 300);
    });
  }

  Reorder() {

    let modalRefAdd = this.modalService.open(EapTypeReorderComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRefAdd.componentInstance.Content={
      heading: 'Reorder',
      content: { operation: "Edit", Data: this.DocumentData },
    }
    modalRefAdd.result.then(result => {
      //this.commonService.SuccessBanner("Order of Fields saved successfully");
      this.DocumentData = result;
      this.loadGrid = false;
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    })
  }
}
